import type { ImageShape } from "@gettactic/map-builder/src/types";
import React from "react";
import { buildWorldShapeTransform } from "../shapeTransform";

export interface ImageSvgProps {
  shape: ImageShape;
}

export const ImageSvg: React.FC<ImageSvgProps> = ({ shape }) => (
  <image
    x={shape.x}
    y={shape.y}
    width={shape.width}
    height={shape.height}
    href={shape.path}
    transform={buildWorldShapeTransform(shape)}
  />
);
